/* 
  Custom Page Reducers
  Handles actions related to custom pages.
  Currently only handles setting the pages.
*/

import { PayloadAction } from '@reduxjs/toolkit';
import { PagesApiResponse } from 'system/types/interfaces/IAdvancedReporting';
import { ICustomPagesState } from './custom-page-state';

const customPagesReducers = {

  setPages: (state: ICustomPagesState, action: PayloadAction<PagesApiResponse>) => {
    const { UserPages, CustomerPages, GlobalPages } = action.payload;
    
    const allPages = [
      ...(UserPages     ?? []),
      ...(CustomerPages ?? []),
      ...(GlobalPages   ?? []),
    ];

    state.pages = allPages.sort((a, b) => a.displayOrder - b.displayOrder);
    state.currentPageId = state.pages[0]?.id ?? null;
  },

  setCurrentPageId: (state: ICustomPagesState, action: PayloadAction<number>) => {
    state.currentPageId = action.payload;
  },

};

export default customPagesReducers;